<script></script>

<!-- <hr> -->
<br />
<br />
<br />
<section id="resources">
  <br />
  <h3 class="body-header">References + Open Source</h3>
  <p class="body-text">
    This article is a product of the following resources + the awesome people
    who made (and contributed to) them:
  </p>
  <br />
  <p class="resource-item">
    <a
      class="on-end"
      href="https://www.researchgate.net/publication/228529307_Evaluation_From_Precision_Recall_and_F-Factor_to_ROC_Informedness_Markedness_Correlation"
      >Evaluation: From Precision, Recall and F-Factor to ROC, Informedness,
      Markedness & Correlation</a
    ><br />
    (David Martin Ward Powers, 2008).
  </p>
  <p class="resource-item">
    <a
      class="on-end"
      href="https://link.springer.com/article/10.1007/BF00116251"
      >Classification assessment methods</a
    ><br />
    (John Ross Quinlan, 1986).
  </p>
  <p class="resource-item">
    <a class="on-end" href="https://d3js.org/">D3.js</a><br />(Mike Bostock &
    Philippe Rivière)
  </p>
  <p class="resource-item">
    <a class="on-end" href="https://layercake.graphics/">LayerCake</a><br
    />(Michael Keller)
  </p>
  <p class="resource-item">
    <a class="on-end" href="https://katex.org/">KaTeX</a> <br />(Emily Eisenberg
    & Sophie Alpert)
  </p>
  <p class="resource-item">
    <a class="on-end" href="https://svelte.dev/">Svelte</a><br />(Rich Harris)
  </p>
  <br />
  <br />
  <br />
</section>

<style>
  #resources {
    background-color: #504bab;
    color: white;
  }

  .resource-item {
    max-width: 600px;
    margin: 0 auto;
    text-align: left;
    font-size: 17px;
    line-height: 1.5em;
    font-family: "Amazon Ember";
    color: white;
  }

  a.on-end {
    text-decoration: underline;
    color: #f1f3f3;
  }

  /* mobile */
  @media screen and (max-width: 950px) {
    .resource-item {
      max-width: 80%;
      font-size: 18px;
    }
  }
</style>
